import RoomPreferencesIcon from "@mui/icons-material/RoomPreferences";
import { resources as Declarations } from "./Declarations";
import { resources as SpecificRequirements } from "./SpecificRequirements";
import { resources as Exams } from "./Exams";
import { resources as Courses } from "./Courses";
import { resources as Intermediaries } from "./Intermediaries";
import { resources as Preferences } from "./Preferences";
import { resources as GradingScales } from "./GradingScales";
import { resources as SchoolSubjects } from "./SchoolSubjects";
import { tenants } from "utils/tenants";

export const resources = {
  isMenu: true,
  tenancies: [tenants.MU],
  icon: <RoomPreferencesIcon />,
  name: "КСК Настройки",
  title: "КСК Настройки",
  subMenu: [
    Declarations,
    SpecificRequirements,
    Exams,
    Courses,
    Intermediaries,
    Preferences,
    GradingScales,
    SchoolSubjects,
  ],
};
